import HttpClient from 'CmsManagePreferences/api/client';
import { ENDPOINTS, constructApiEndpoint } from 'CmsManagePreferences/api/endpoints';
const FEEDBACK_SURVEY_OPTIONS = {
  NO_LONGER_INTERESTED: 'NO_LONGER_INTERESTED',
  DID_NOT_SIGN_UP: 'DID_NOT_SIGN_UP',
  TOO_MANY_EMAILS: 'TOO_MANY_EMAILS',
  IRRELEVANT_CONTENT: 'IRRELEVANT_CONTENT',
  OTHER: 'OTHER'
};
export const submitSurvey = async (payload, dataParam) => {
  const httpClient = new HttpClient();
  const url = new URL(constructApiEndpoint(ENDPOINTS.SUBMIT_SURVEY), window.location.origin);
  url.searchParams.set('data', dataParam);
  return httpClient.post(url.toString(), JSON.stringify(payload));
};